<template>
    <div>
        <v-card class="mb-6">
            <v-card-title class="text-h5">Lista module gard</v-card-title>
            <v-data-table :headers="headers" :items="fence" class="elevation-1 pb-2" dense hide-default-footer>
                <template v-slot:item.name="{ item }">
                    <span class="font-weight-bold">{{ denumireModulGard(item.tip, item.tip_poarta_mare) }}</span>
                </template>
                <template v-slot:item.slats="{ item }">
                    {{ `${item.nr_profile} x ${item.latime_profil} mm` }}
                </template>
                <template v-slot:item.dimensions="{ item }">
                    {{ `${item.latime} x ${item.inaltime} mm | ${Number(item.suprafata).toFixed(2)} m²` }}
                </template>
            </v-data-table>
        </v-card>
        <v-card>
            <v-card-title class="text-h5">Lista materiale gard</v-card-title>
            <v-data-table-header>
                <v-data-table-header-item v-for="(header, index) in headers" :key="index" :text="header.text"
                    :value="header.value" :align="header.align || 'start'">
                    <span class="font-weight-bold">{{ header.text }}</span>
                </v-data-table-header-item>
            </v-data-table-header>
            <v-simple-table v-for="item in fence" :key="item.nr" class="pb-2 mb-4" dense>
                <thead>
                    <tr>
                        <th class="text-left">
                            <span class="text-lg">
                                {{ denumireModulGard(item.tip, item.tip_poarta_mare) }}
                            </span>
                        </th>
                    </tr>
                </thead>
                <ModuleMaterials :module="item" />
            </v-simple-table>
            <!-- <v-data-table :headers="headers" :items="fence" class="elevation-1" hide-default-header hide-default-footer>
                <template v-slot="item">
                    <span>{{ item.nr }}</span>
                    <span>{{ item.tip }}</span>
                    <span>{{ item.denumire_model }}</span>
                    <span>{{ `${item.latime} x ${item.inaltime} mm` }}</span>
                    <span>{{ `${item.nr_profile} x ${item.latime_profil} mm` }}</span>
                    <span class="text-center">{{ item.buc }}</span>
                </template>
                <template v-slot:item.slats="{ item }">
                    {{ `${item.nr_profile} x ${item.latime_profil} mm` }}
                </template>
                <template v-slot:item.dimensions="{ item }">
                    {{ `${item.latime} x ${item.inaltime} mm | ${Number(item.suprafata).toFixed(2)} m²` }}
                </template>
            </v-data-table> -->
        </v-card>
        {{ fence }}
    </div>
</template>

<script>
import ModuleMaterials from './ModuleMaterials.vue';

export default {
    name: 'FenceMaterialsBill',
    components: {
        ModuleMaterials
    },
    props: {
        fence: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            headers: [
                { text: 'Nr.', value: 'nr' },
                { text: 'Modul', value: 'name' },
                { text: 'Model', value: 'denumire_model' },
                { text: 'Dimensiuni ( l x h )', value: 'dimensions' },
                { text: 'Lamele', value: 'slats' },
                { text: 'Cantitate', value: 'buc', align: 'center' }
            ],
        };
    },
    computed: {
        // Computed properties can be added here if needed
    },
    methods: {
        denumireModulGard(str, tip_poarta) {
            if (str == "Panou") {
                str += " gard";
            }
            if (str == "Panou_rama") {
                str += "";
            }
            if (str == "Poarta_mica") {
                str += "_pietonala";
            }
            if (str == "Poarta_mare") {
                str += `_${tip_poarta}`;
            }
            let newStr = str.replace(/_/g, " ");
            return newStr;
        },
    }
}
</script>